import RoleView from "../../Navigation/RoleView";
import TeachrCoursesV2 from "../../App/CoursesV2/TeachrCoursesV2";
import ClientCoursesV2 from "../../App/ClientV2/ClientCoursesV2";

/**
 * « Mes cours » du tableau de bord commun, version repensée (maquettes 6a, 6b,
 * 6c) : la vue prof est `TeachrCoursesV2`, la vue client `ClientCoursesV2`.
 * Les anciennes pages (`CoursePage`, `TeachrCourses`, `ClientCourses`) sont
 * conservées dans le code.
 */
const CourseListV2Page = () => (
    <RoleView prof={<TeachrCoursesV2 />} client={<ClientCoursesV2 />} />
);

export default CourseListV2Page;
